<template>
    <div class="bo-attachment">
        <div class="attachment-list">
            <div
                class="attachment-item"
                v-for="(attachment, attachmentId, index) in attachments"
                :key="attachmentId"
            >
                <template v-if="index <= displayLength || noMaxDisplayLength">
                    <template v-if="index == displayLength && !noMaxDisplayLength">
                        <div class="attachment-frame">
                            <span @click="showDropdown = !showDropdown">
                                +{{ Object.keys(attachments).length - displayLength }}
                            </span>
                        </div>
                        <div
                            v-if="showDropdown && attachmentLength > displayLength"
                            aria-labelledby="dropdownAddItem"
                            class="dropdown-menu dropdown-menu-right"
                            style="display: block; float: right"
                            v-click-outside="hidePopup"
                        >
                            <div class="popup-trigger">
                                <div class="quick-search-group">
                                    <template v-for="(attachment, attachmentId) in attachments">
                                        <template v-if="index >= displayLength">
                                            <div
                                                class="document is-zip"
                                                :key="attachmentId"
                                            >
                                                <template>
                                                    <span
                                                        v-if="isImage(attachment.source_url)"
                                                        @click="viewFile(index)"
                                                    >
                                                        {{ getFileName(attachment.source_url) }}
                                                    </span>
                                                    <span
                                                        v-else
                                                        @click="openFile(attachment.source_url)"
                                                    >
                                                        {{ getFileName(attachment.source_url) }}
                                                    </span></template
                                                ><i
                                                    v-if="editable"
                                                    class="icon-close"
                                                    @click="removeFile(attachmentId)"
                                                ></i>
                                            </div>
                                        </template>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div
                            v-if="isImage(attachment.source_url)"
                            class="attachment-frame is-img"
                            @click="viewFile(index)"
                        >
                            <img
                                :src="attachment.source_url"
                                alt="N/A"
                            />
                        </div>
                        <div
                            v-else-if="isPDF(attachment.source_url)"
                            class="attachment-frame is-pdf"
                            @click="openFile(attachment.source_url)"
                        >
                            <i class="icon-pdf"></i>
                        </div>
                        <div
                            v-else-if="isExcel(attachment.source_url)"
                            class="attachment-frame"
                            @click="openFile(attachment.source_url)"
                        >
                            <i class="icon-microsoftexcel"></i>
                        </div>
                        <div
                            v-else-if="isCSV(attachment.source_url)"
                            class="attachment-frame"
                            @click="openFile(attachment.source_url)"
                        >
                            <i class="icon-attachfile"></i>
                        </div>
                        <div
                            v-if="isZIP(attachment.source_url)"
                            class="attachment-frame is-zip"
                            @click="openFile(attachment.source_url)"
                        >
                            <i class="icon-pdf"></i>
                        </div>
                        <i
                            v-if="editable"
                            class="icon-close"
                            @click="removeFile(attachmentId)"
                        ></i>
                    </template>
                </template>
            </div>

            <div
                v-if="editable && (attachmentLength < length || noMaxLength)"
                class="document-add"
            >
                <label
                    class="icon-add"
                    :for="id"
                ></label>
                <!-- <label
                    v-if="iconType == 'FileAttachment'"
                    class="icon-attachfile"
                    :for="id"
                ></label>
                <label
                    v-else-if="iconType == 'AddFileAttachment'"
                    class="icon-add"
                    :for="id"
                ></label>
                <label
                    v-else-if="iconType == 'UploadFile'"
                    class="icon-cloudupload"
                    :for="id"
                ></label>
                <label
                    v-else
                    class="text-arclight cursor-pointer"
                    :for="id"
                >
                    <i class="icon-add"></i>
                    {{ documentText }}
                </label> -->
                <input
                    :id="id"
                    :ref="'fileUpload'"
                    type="file"
                    multiple="multiple"
                    class="input_add_document file-upload icon"
                    @input="
                        addFiles($event);
                        resetFileInput();
                    "
                />
            </div>
            <div v-else-if="!editable && Object.keys(attachments).length == 0">-</div>
        </div>
        <div v-show="supportedFileTypes.length > 0">
            <span
                >{{ generalTranslations.supported_formats ?? "Supported formats:" }}
                <span v-for="(supportedFileType, index) in supportedFileTypes"
                    >{{ supportedFileType }}<span v-if="index < supportedFileTypes.length - 1">, </span></span
                >
            </span>
        </div>
        <div
            v-if="showItemCount"
            class="d-flex justify-content-between mt-1 w-100"
        >
            <span style="opacity: 0.6">{{ attachmentItems() }}</span>
        </div>
        <!-- Error Message -->
        <div
            v-show="error"
            class="error"
        >
            <i class="icon-cancelcircle-1"></i>
            {{ error }}
        </div>
        <!-- <light-box
            v-if="attachmentLength"
            ref="imageViewer"
            :media="lightboxImages"
            :showLightBox="showLightBox"
        ></light-box> -->
    </div>
</template>

<script>
import Vue from "vue";
import VueLazyLoad from "vue-lazyload";
import mediaMixin from "@/v2/mixins/medias";
import { v4 as uuidv4 } from "uuid";
Vue.use(VueLazyLoad);

// import LightBox from "vue-image-lightbox";
// import "vue-image-lightbox/dist/vue-image-lightbox.min.css";
import "viewerjs/dist/viewer.css";
import { api as viewerApi } from "v-viewer";

export default {
    // components: {
    //     LightBox,
    // },

    mixins: [mediaMixin],

    props: {
        editable: {
            type: Boolean,
            default: true,
        },
        value: {
            type: Object,
            default: () => ({}),
        },
        displayLength: {
            type: Number,
            default: 3,
        },
        noMaxDisplayLength: {
            type: Boolean,
            default: false,
        },
        length: {
            type: Number,
            default: 5,
        },
        noMaxLength: {
            type: Boolean,
            default: false,
        },
        documentText: {
            type: String,
            default: "Add Attachments",
        },
        iconType: {
            type: String,
            default: "AddFileAttachment",
        },
        row: {
            type: String,
            default: null,
        },
        column: {
            type: String,
            default: null,
        },
        supportedFileTypes: {
            type: Array,
            default: () => [],
        },
        showItemCount: {
            type: Boolean,
            default: true,
        },
    },

    model: {
        prop: "value",
        event: "change",
    },
    computed: {
        attachments: {
            get() {
                return this.value ?? {};
            },
            set(newValue) {
                this.$emit("change", newValue);
            },
        },
        attachmentLength: {
            get() {
                return Object.keys(this.attachments).length;
            },
        },
        lightboxImages: {
            get() {
                return Object.values(this.value).map((attachment) => {
                    return {
                        thumb: attachment.source_url,
                        src: attachment.source_url,
                    };
                });
            },
        },
        unsupportedTypeErrorMessage() {
            return `The uploaded file format is not supported.`;
        },
    },

    data() {
        return {
            error: "",
            // showLightBox: false,
            showDropdown: false,
            id: "file-upload-" + uuidv4(),
            generalTranslations: window.bo?.generalTranslations ?? {},
        };
    },

    methods: {
        attachmentItems() {
            let unit = " ".concat(this.generalTranslations?.item_message ?? " Item(s)");
            return this.attachmentLength + unit;
        },
        getFileName(url) {
            //https://stackoverflow.com/questions/190852/how-can-i-get-file-extensions-with-javascript
            return url.slice((Math.max(0, url.lastIndexOf("/")) || Infinity) + 1);
        },

        getFileExtension(filename) {
            //https://stackoverflow.com/questions/190852/how-can-i-get-file-extensions-with-javascript
            return filename.slice((Math.max(0, filename.lastIndexOf(".")) || Infinity) + 1).toLowerCase();
        },

        isImage(filename) {
            let fileExtension = this.getFileExtension(filename);
            return (
                fileExtension === "svg" ||
                fileExtension === "jpg" ||
                fileExtension === "png" ||
                fileExtension === "jpeg" ||
                fileExtension === "jfif" ||
                fileExtension === "gif" ||
                fileExtension === "bmp" ||
                fileExtension === "webp"
            );
        },

        isPDF(filename) {
            let fileExtension = this.getFileExtension(filename);
            return fileExtension === "pdf";
        },

        isExcel(filename) {
            let fileExtension = this.getFileExtension(filename);
            return (
                fileExtension === "xls" ||
                fileExtension === "xlsx" ||
                fileExtension === "xlsm" ||
                fileExtension === "xlsb"
            );
        },

        isCSV(filename) {
            let fileExtension = this.getFileExtension(filename);
            return fileExtension === "csv";
        },

        isZIP(filename) {
            let fileExtension = this.getFileExtension(filename);
            return fileExtension === "zip";
        },

        addFiles(event) {
            let temp = Object.assign({}, this.attachments);
            this.error = "";

            let files = Array.from(event.target.files);
            if (files) {
                if (this.attachmentLength + files.length <= this.length || this.noMaxLength) {
                    files.forEach((file) => {
                        if (this.supportedFileTypes.length > 0) {
                            if (this.supportedFileTypes.includes(this.getFileExtension(file.name))) {
                                this.createMedia(file, (media) => {
                                    this.$set(temp, media.id, media);
                                    this.attachments = temp;
                                });
                            } else {
                                this.error = this.unsupportedTypeErrorMessage;
                            }
                        } else {
                            this.createMedia(file, (media) => {
                                this.$set(temp, media.id, media);
                                this.attachments = temp;
                            });
                        }
                    });
                } else {
                    this.error = `Maximum number of files is ` + this.length;
                }
            }

            event.target.files = null;
        },

        removeFile(id) {
            this.$emit("delete", id);
            const temp = Object.assign({}, this.attachments);
            delete temp[id];
            this.attachments = temp;
        },

        viewFile(index) {
            // this.$refs.imageViewer.showImage(index);

            if (this.attachmentLength) {
                viewerApi({
                    options: {
                        inline: true,
                        button: true,
                        navbar: true,
                        title: false,
                        toolbar: false,
                        tooltip: true,
                        movable: true,
                        zoomable: true,
                        rotatable: false,
                        scalable: false,
                        transition: true,
                        fullscreen: true,
                        keyboard: true,
                        url: "src",
                        initialViewIndex: index,
                    },
                    images: this.lightboxImages,
                });
            }
        },

        openFile(url) {
            window.open(url, "_blank");
        },

        resetFileInput() {
            this.$refs.fileUpload.value = null;
        },

        hidePopup() {
            this.showDropdown = false;
        },
    },
};
</script>
